module.exports = __webpack_public_path__ + "static/media/gift.f6bd1513.svg";